import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../util/network-call/network-call";

export const AdminDeviceEditLoader = async (args: LoaderFunctionArgs) => {

    const response = await networkCall(`/devices/${ args.params.id }`);

    return { response, id: args.params.id };

};